import styles from './parts.module.css';

export function DismissButton({ onClick, className }: { onClick: () => void; className?: string }) {
    return (
        <button
            type="button"
            className={[styles.dismiss, className].filter(Boolean).join(' ')}
            onClick={onClick}
            aria-label="Dismiss"
        >
            <svg viewBox="0 0 16 16" aria-hidden="true">
                <path
                    d="M3.5 3.5l9 9m0-9l-9 9"
                    stroke="currentColor"
                    strokeWidth="1.75"
                    strokeLinecap="round"
                />
            </svg>
        </button>
    );
}
